/**
 * @author [Sujan Basnet]
 * @email [basnetsujan95@gmail.com]
 * @create date 2019-03-25 15:53:18
 * @modify date 2019-03-25 15:53:18
 * @desc [description]
*/

import React from 'react';

import { Menu, Responsive, Image } from 'semantic-ui-react';
import { NavLink, Redirect } from 'react-router-dom';

import logo from '../../logo.png';
import bars from './assets/svg/menu.svg';

import styles from './navbar.module.scss';

// import { PropTypes } from 'prop-types';
import ButtonsOr from '../buttonsOr/buttonsor';

const NAV_LINKS = [
    {
        "link": "/",
        "name": "Home"
    },
    {
        "link": "/projects",
        "name": "Projects"
    },
    {
        "link": "/about",
        "name": "About"
    },
    {
        "link": "/contact",
        "name": "Contact"
    },
]

export default class Navbar extends React.Component {

    constructor() {
        super();
        this.state = {
            visible: false,
            redirectTo: null
        }
    }

    _toggleNavbar = (show = false) => {

        this.setState({
            visible: show,
        });
    }

    _redirectTo = (page) => {
        this.setState({
            redirectTo: page
        });
    }

    render() {

        const {visible, redirectTo} = this.state;
        const { _closeModal, _openModal } = this.props;

        if(redirectTo !== null) {
            this._redirectTo(null);
            return <Redirect to={`/${redirectTo}`} />
        }

        return (

            <nav className={styles.navbar}>

                <Menu secondary className={styles.navMenu}>

                    <Responsive maxWidth={850}>
                        <div className={styles.barsWrapper}>
                            <Image onClick={e => this._toggleNavbar(!this.state.visible)} className={styles.bars} src={bars} name="bars" />
                            <Menu.Item 
                                
                                name='home' 
                                children={<NavLink to="/"><img className={styles.logo} src={logo} alt="logo" /></NavLink>}
                            />
                        </div>
                    </Responsive>

                    <Responsive minWidth={851}>
                        <Menu.Item 
                            
                            name='home' 
                            children={<NavLink to="/"><img className={styles.logo} src={logo} alt="logo" /></NavLink>}
                        />
                    </Responsive>
                    
                    <Responsive maxWidth={850}>
                        <NavSmallScreen _toggleNavbar={this._toggleNavbar} visible={visible} navLinks={NAV_LINKS} />
                    </Responsive>
                    <Responsive as={Menu} secondary minWidth={851}>
                        <NavLargeScreen navLinks={NAV_LINKS} />
                    </Responsive>

                    <Menu.Item
                        name='buttons'
                        children={
                            <ButtonsOr 
                                shouldReduce={true} 
                                firstCondition="BOOK NOW" 
                                secondCondition="GET QUOTE" 
                                secondLink="/contact" 
                                onClickFirst={_openModal}
                                onClickSecond={e => this._redirectTo('contact')} 
                            />
                        }
                    />

                </Menu>

            </nav>
        
        );

    }

}

const NavLargeScreen = ({ navLinks }) => (
    <Menu.Menu>
        <Menu secondary>
            {
                navLinks && navLinks.map((navLink, i) => (
                    <Menu.Item
                        key={i}
                        className={styles.navItem}
                        name={navLink.name}
                        children={<NavLink exact activeClassName={styles.active} to={`${navLink.link}`}>{navLink.name}</NavLink>}
                    />
                ))
            }
        </Menu>
    </Menu.Menu>
  );
  
const NavSmallScreen = ({ navLinks, visible, _toggleNavbar }) => (
    <Menu.Menu>
        <Menu secondary vertical className={`${styles.verticalNavbar} ${visible ? styles.visible : ''}`}>
        {
            navLinks && navLinks.map((navLink, i) => (
                <Menu.Item
                    key={i}
                    className={styles.navItem}
                    name={navLink.name}
                    children={<NavLink exact activeClassName={styles.active} to={`${navLink.link}`} onClick={e => _toggleNavbar(false)}>{navLink.name}</NavLink>}
                />
            ))
        }
        </Menu>
    </Menu.Menu>
);
